import { render, staticRenderFns } from "./RiviewIcon.vue?vue&type=template&id=aefd4c26"
import script from "./RiviewIcon.vue?vue&type=script&lang=js"
export * from "./RiviewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports